import React from 'react';
import { Flex } from '@chakra-ui/react';
import FilterChip from './FilterChip';

export default function ComprehensiveFilterChips({ filters, updateFilter, showDateRange = true, showProject = true, showCompareTo = true }) {
  const activeFilters = [];

  	// Add filter chips for active filters
	if (showProject && filters.project) {
		activeFilters.push({
			key: 'project',
			label: 'Project',
			value: filters.project,
			onClear: () => updateFilter('project', '')
		});
	}

  if (filters.environment) {
    activeFilters.push({
      key: 'environment',
      label: 'Environment',
      value: filters.environment,
      onClear: () => updateFilter('environment', '')
    });
  }

  if (filters.branch) {
    activeFilters.push({
      key: 'branch',
      label: 'Branch',
      value: filters.branch,
      onClear: () => updateFilter('branch', '')
    });
  }

  if (filters.status) {
    activeFilters.push({
      key: 'status',
      label: 'Status',
      value: filters.status,
      onClear: () => updateFilter('status', '')
    });
  }

  if (filters.group) {
    activeFilters.push({
      key: 'group',
      label: 'Group',
      value: filters.group,
      onClear: () => updateFilter('group', '')
    });
  }

  if (filters.user) {
    activeFilters.push({
      key: 'user',
      label: 'User',
      value: filters.user,
      onClear: () => updateFilter('user', '')
    });
  }

  if (showDateRange && filters.dateRange && filters.dateRange !== '') {
    let dateValue = filters.dateRange;
    if (filters.startDate && filters.endDate) {
      dateValue = `${filters.startDate} → ${filters.endDate}`;
    }
    activeFilters.push({
      key: 'dateRange',
      label: 'Date',
      value: dateValue,
      onClear: () => {
        updateFilter('dateRange', '');
        updateFilter('startDate', '');
        updateFilter('endDate', '');
      }
    });
  }

  if (filters.period && filters.period !== 'daily') {
    activeFilters.push({
      key: 'period',
      label: 'Period',
      value: filters.period,
      onClear: () => updateFilter('period', 'daily')
    });
  }

  	if (showCompareTo && filters.compareTo) {
		activeFilters.push({
			key: 'compareTo',
			label: 'Comparison',
			value: 'Enabled',
			onClear: () => updateFilter('compareTo', false)
		});
	}

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <Flex wrap="wrap" gap={2} mb={4}>
      {activeFilters.map(filter => (
        <FilterChip
          key={filter.key}
          label={filter.label}
          value={filter.value}
          onClear={filter.onClear}
        />
      ))}
    </Flex>
  );
}
